import { Spinner, Table } from '@dixa/lib-shared-habla';

import styles from './tableLoadingRow.module.scss';

type PropsT = {
  colSpan?: number;
};

export const TableLoadingRow = ({ colSpan }: PropsT) => (
  <Table.Tr>
    <Table.Td align="center" colSpan={colSpan}>
      <Spinner />
      <div className={styles.text}>Loading...</div>
    </Table.Td>
  </Table.Tr>
);
